export enum SquidexPromoSectionLinkTypes {
  WITH_NO_LINK = "brak",
  EXTERNAL_LINK = "zewnętrzne",
  INTERNAL_LINK = "wewnętrzne",
  SCROLL_TO_SECTION = "przewiń do sekcji",
}
